import { render, staticRenderFns } from "./BodyMap.vue?vue&type=template&id=0882df9c&scoped=true"
import script from "./BodyMap.vue?vue&type=script&lang=js"
export * from "./BodyMap.vue?vue&type=script&lang=js"
import style0 from "./BodyMap.vue?vue&type=style&index=0&id=0882df9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0882df9c",
  null
  
)

export default component.exports